<template>
    <v-card
            v-if="this.selectedItem"
            class="pre_cart_info mx-auto p-5"
            outlined
    >
        <v-list-item three-line>


            <v-avatar class="m-5 text-center " style="      height: AUTO;
    min-width: 100px;
    border-radius: 0;
    margin: 15px auto;
    width: 100%;">
                <img :src="selectedItem.image" alt="selectedItem.name">
            </v-avatar>

        </v-list-item>
        <v-list-item-title class="mb-1 text-center" id="dynamicSelectedProductID" style="font-size: 13px;">
            {{dynamicSelectedProductID}}
        </v-list-item-title>
        <v-list-item-title class="mb-1 text-center">
            PRICE: <strong>{{dynamicSelectedProductIDPrice|formatCurrency}}</strong>
        </v-list-item-title>

    </v-card>
</template>

<script>
    export default {
        name: "SideBar",
        watch: {


            dynamicSelectedProductID(newValue) {
                this.setDynamicSelectedProductID(newValue)

            },

        },
        data: function () {
            return {
                links: []
            };
        }
        ,
        computed: {


            dynamicSelectedProductID() {
                if (this.product_id == '' || !this.selectedItem) {
                    return '';
                }

                let dynamicSelectedProductIDString = this.selectedItem.name;

                if (this.dll || this.secure_programming) {
                    dynamicSelectedProductIDString = dynamicSelectedProductIDString + '-';
                    if (this.dll) {
                        dynamicSelectedProductIDString = dynamicSelectedProductIDString + 'D';
                    }
                    if (this.secure_programming) {
                        dynamicSelectedProductIDString = dynamicSelectedProductIDString + 'S';
                    }
                }


                let devices_rows_count = 0;
                //devices_rows_count--;

                let ar_listAlgorithmsRows = [];
                //get algoritms from devices rows
                //console.log('+++++++++++++');
                //console.log(this.devices_rows);algorithm_list:Object
                let algorithm_list = this.algorithm_list;
                //console.log('devices_rows= ' + this.devices_rows);
                this.devices_rows.map(devices_row => {

                    if(typeof devices_row.device_id === 'object' && devices_row.device_id !== null ) {


                     //   console.log('devices_rows2.algorithm= --' + devices_row.device_id.algorithm);










                        let algorithm_payable = algorithm_list[devices_row.device_id.algorithm];
                       // console.log(algorithm_payable.id);
                        //console.log(algorithm_payable.algorithm_payable);



                    if (algorithm_payable.algorithm_payable == '1' && !ar_listAlgorithmsRows.includes(devices_row.device_id.algorithm)) {
                        ar_listAlgorithmsRows.push(devices_row.device_id.algorithm);
                        console.log('---');
                        console.log(ar_listAlgorithmsRows);
                        devices_rows_count++;
                    }

                        console.log('++');
                        console.log(devices_row.device_id.algorithm);
                    }

                });


                //console.log(ar_listAlgorithmsRows);


                console.log('devices_rows_count=' + devices_rows_count);

              if (this.selectedItem.category == 'Hardware') {
                dynamicSelectedProductIDString =  dynamicSelectedProductIDString.replace('Portable', 'PORT');
                dynamicSelectedProductIDString =  dynamicSelectedProductIDString.replace(')-', ')!');
                dynamicSelectedProductIDString =  dynamicSelectedProductIDString.replace('-', '');
                dynamicSelectedProductIDString =  dynamicSelectedProductIDString.replace(')!', ')-');

              }



              if (devices_rows_count > 0 && this.devices_rows[0].device_id) {
                // console.log('devices_rows_count=' + devices_rows_count);
                dynamicSelectedProductIDString = dynamicSelectedProductIDString + '-' + 'FAM' + devices_rows_count;
              }

              if (devices_rows_count == 0 && this.devices_rows[0].device_id && this.selectedItem.category == 'Hardware') {
                dynamicSelectedProductIDString = dynamicSelectedProductIDString + '-' + 'BASE' ;
              }

                return dynamicSelectedProductIDString;
            }

        },
        methods: {
            getLinks: function () {
                this.links = this.$store.state.links;
            }
        },
        created: function () {
            this.getLinks();
        },
        props: [
           'algorithm_list', 'devices_rows', 'selectedItem', 'dynamicSelectedProductIDPrice', 'pricing', 'setDynamicSelectedProductID', 'product_id', 'items', 'secure_programming', 'qty', 'dll'
        ]
    }
</script>
<style>


    .pre_cart_info {
        position: -webkit-sticky !important;
        position: sticky !important;
        top: 90px;
    }

</style>
